import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Layout, Switch as AntSwitch, Tooltip } from "antd";
import {
	MenuFoldOutlined,
	MenuUnfoldOutlined,
	BulbOutlined,
	QuestionCircleOutlined,
} from "@ant-design/icons";
import NavSearch from "./NavSearch";
import {
	toggleCollapsedNav,
	onMobileNavToggle,
	onSwitchTheme,
} from "redux/actions/Theme";
import { NAV_TYPE_TOP } from "constants/ThemeConstant";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import utils from "utils";
import NavProfile from "./NavProfile";
import NavNotification from "./NavNotification";
import NavNome from "./NavNome";
import NavAlertas from "./NavAlertas";
import NavJornada from "./NavJornada";

const { Header } = Layout;

export const HeaderNav = (props) => {
	const {
		navCollapsed,
		mobileNav,
		navType,
		headerNavColor,
		toggleCollapsedNav,
		onMobileNavToggle,
		onSwitchTheme,
		isMobile,
		currentTheme,
		hideMenuToggle,
	} = props;
	const history = useHistory();
	const [searchActive, setSearchActive] = useState(false);

	const onSearchClose = () => {
		setSearchActive(false);
	};

	const onToggle = () => {
		if (!isMobile) {
			toggleCollapsedNav(!navCollapsed);
		} else {
			onMobileNavToggle(!mobileNav);
		}
	};

	const onThemeChange = (checked) => {
		onSwitchTheme(checked ? "dark" : "light");
	};

	const isNavTop = navType === NAV_TYPE_TOP ? true : false;
	const mode = () => {
		if (!headerNavColor) {
			return utils.getColorContrast(
				currentTheme === "dark" ? "#00000" : "#ffffff",
			);
		}
		return utils.getColorContrast(headerNavColor);
	};
	const navMode = mode();

	useEffect(() => {
		if (!isMobile) {
			onSearchClose();
		}
	});

	return (
		<Header
			className={`app-header ${navMode}`}
			style={{
				backgroundColor: headerNavColor,
				maxWidth: "100%",
				overflowX: "hidden",
			}}
		>
			<div
				className={`app-header-wrapper ${
					isNavTop ? "layout-top-nav" : ""
				}`}
				style={{ maxWidth: "100%" }}
			>
				{/* <Logo logoType={navMode} /> */}
				<div
					className="nav"
					style={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
				>
					{isMobile && !hideMenuToggle && (
						<div className="nav-left">
							<ul
								className="ant-menu ant-menu-root ant-menu-horizontal"
								style={{ display: "flex" }}
							>
								<li
									className={`ant-menu-item ant-menu-item-only-child open-close-menu ${
										isMobile ? "nav-icon-mobile" : ""
									}`}
									onClick={() => {
										onToggle();
									}}
								>
									{navCollapsed || isMobile ? (
										<MenuUnfoldOutlined
											style={{
												transform: "translateY(4px)",
											}}
											className="nav-icon"
										/>
									) : (
										<MenuFoldOutlined
											style={{
												transform: "translateY(4px)",
											}}
											className="nav-icon"
										/>
									)}
								</li>
							</ul>
						</div>
					)}

					<NavJornada isMobile={isMobile} />

					<div className="nav-right">
						{!isMobile && (
							<div
								className="dark-mode-switch"
								style={{
									marginRight: "15px",
									display: "flex",
									alignItems: "center",
								}}
							>
								<BulbOutlined
									style={{
										marginRight: "8px",
										fontSize: "16px",
										color:
											currentTheme === "dark"
												? "#fff"
												: undefined,
									}}
								/>
								<AntSwitch
									checked={currentTheme === "dark"}
									onChange={onThemeChange}
									checkedChildren="🌙"
									unCheckedChildren="☀️"
								/>
							</div>
						)}
						{!isMobile && (
							<div
								style={{
									display: "flex",
									alignItems: "center",
									marginRight: "15px",
									cursor: "pointer",
									color:
										currentTheme === "dark"
											? "#fff"
											: undefined,
								}}
								onClick={() =>
									history.push(
										`${APP_PREFIX_PATH}/suporte`,
									)
								}
							>
								<QuestionCircleOutlined
									style={{
										fontSize: "18px",
										marginRight: "6px",
									}}
								/>
								<span style={{ fontSize: "14px" }}>
									Suporte
								</span>
							</div>
						)}
						<NavAlertas isMobile={isMobile} />
						<NavNotification mode={navMode} />
						{!isMobile && (
							<NavNome mode={navMode} isMobile={isMobile} />
						)}
						<NavProfile isMobile={isMobile} />
						{/* <NavPanel direction={direction} />  Aqui que tem as configurações de tela, se quiser testar*/}
					</div>
					<NavSearch active={searchActive} close={onSearchClose} />
				</div>
			</div>
		</Header>
	);
};

const mapStateToProps = ({ theme }) => {
	const {
		navCollapsed,
		navType,
		headerNavColor,
		mobileNav,
		currentTheme,
		direction,
	} = theme;
	return {
		navCollapsed,
		navType,
		headerNavColor,
		mobileNav,
		currentTheme,
		direction,
	};
};

export default connect(mapStateToProps, {
	toggleCollapsedNav,
	onMobileNavToggle,
	onSwitchTheme,
})(HeaderNav);
